<!-- 搜索商品详情 -->
<template>
  <div class="page-content">
    <c-header pageName="商品信息"></c-header>
    <div class="content flex-wrap">
      <div class="header flex-wrap">
        <section>商品名称 : {{ product.productName }}</section>
        <section>国际条码 : {{ product.barCode }}</section>
        <section>规格 : {{ product.specVal }}</section>
        <section>可用库存 : {{ product.qty }}</section>
        <section>在板数据 : {{ product.bandQty }} 条</section>
      </div>
      <div class="detail-list" v-if="product.stockInfos">
        <div
          class="order-item"
          v-for="(item,index) in product.stockInfos"
          :key="index"
        >
          <section>库位 : {{ item.slCode }}</section>
          <section>板号 : {{ item.bandSn }}</section>
<!--          <section>项次 : {{ item.itemSn }}</section>-->
          <section>可用库存 : {{ item.stockDataOne.unassignedQty || 0}}</section>
          <section>效期 : {{ item.productDate|dateSub }} ~ {{ item.invalidDate|dateSub }}</section>
          <section>不良品状态 :&nbsp;
            <span :style="item.defectFlag ? 'color: #F56C6C' : 'color: #67C23A'">
              {{ item.defectFlag ? "不良品" : "良品" }}
            </span>
          </section>
          <section>库存状态 :&nbsp;
            <div v-for="status in StockStatus()" :key="status.value">
              <span v-if="status.value === item.stockStatus" :style="`color: ${status.color}`"> {{
                  status.label
                }}</span>
            </div>
          </section>
          <section>商品状态 :&nbsp;
            <div v-for="status in ProductStatus()" :key="status.value">
              <span v-if="status.value === item.stockDataOne.productStatus" :style="`color: ${status.color}`"> {{
                  status.label
                }}</span>
            </div>
          </section>
          <section class="tools" @click="handlePrint(item)">
            <span>打印</span>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
import {ProductStatus, StockStatus} from "../common/constant";
import Utils from "../util/utils";
import DataFormat from "../util/dataFormat";

export default {
  data() {
    return {
      productId: "",
      product: []
    };
  },
  components: {
    "c-header": Header
  },
  mounted() {
    this.productId = this.$route.query.productId;
    this.getBanGoodsDetail();
  },
  methods: {
    StockStatus() {
      return StockStatus
    },
    ProductStatus() {
      return ProductStatus
    },
    // 查询商品在板详情
    getBanGoodsDetail() {
      let param = {
        id: this.productId
      };
      this.$post(this.URL.findByProductId, param).then(res => {
        if (res.success) {
          this.product = res.data;
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    //打印
    handlePrint(item) {
      let data = "1," + Utils.formatStr(item.productName, 16, '...') + "," + item.bandSn + ",国际条码:" + item.barCode + ",货主:" +  Utils.formatStr(item.shipper.name, 8, '...') + ",失效日期:" + DataFormat.formatDate(item.invalidDate, "YYYY-MM-DD")
      window.printSupport.share(data)
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 1rem;
  font-size: 0.85rem;
  color: #444;
}

.header {
  padding: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid #dc6350;

  section {
    display: flex;
    width: 100%;
    padding-bottom: 0.3rem;
  }
}

.detail-list {
  width: 100%;
  padding: 0.5rem;

  .order-item {
    border-bottom: 1px dashed #f0f0f0;
    padding: 0.5rem 0;

    section {
      display: flex;
      width: 100%;
      height: 1.3rem;
      align-items: center;
    }

    .tools {
      height: 1.5rem;
      justify-content: flex-end;

      span {
        display: inline-flex;
        width: 4rem;
        height: 1.5rem;
        background-color: #dc6350;
        color: #fff;
        align-items: center;
        justify-content: center;
        border-radius: 0.3rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SearchGoodsDetail.vue